import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export type TimePoint = {
  id: string;
  label: string;
  timestamp: number; // hours
  decisionPoint?: {
    title: string;
    description: string;
  };
};
const timePoints: TimePoint[] = [{
  id: 'now',
  label: 'Now',
  timestamp: 0
}, {
  id: '24h',
  label: '24 hours',
  timestamp: 24
}, {
  id: '48h',
  label: '48 hours',
  timestamp: 48
}, {
  id: '72h',
  label: '72 hours',
  timestamp: 72,
  decisionPoint: {
    title: 'Resupply Needed',
    description: 'Critical resupply point for all units in the area of operations.'
  }
}, {
  id: '96h',
  label: '96 hours',
  timestamp: 96
}, {
  id: '5d',
  label: '5 days',
  timestamp: 120
}, {
  id: '6d',
  label: '6 days',
  timestamp: 144
}, {
  id: '7d',
  label: '7 days',
  timestamp: 168
}];
interface TimelineProps {
  selectedTimePoint: string;
  onTimePointChange: (timePointId: string) => void;
}
export const Timeline: React.FC<TimelineProps> = ({
  selectedTimePoint,
  onTimePointChange
}) => {
  return <div className="h-full py-4 px-4 flex flex-col relative" data-id="element-625">
      {/* Vertical timeline line */}
      <div className="absolute left-6 top-4 bottom-4 w-0.5 bg-gray-300 rounded-full" data-id="element-626" />
      <div className="flex flex-col gap-5 relative pl-8" data-id="element-627">
        {timePoints.map(tp => <div key={tp.id} className="relative" data-id="element-628">
            {/* Black tick mark */}
            <div className="absolute -left-[22px] top-1/2 transform -translate-y-1/2 w-4 h-0.5 bg-black z-10" data-id="element-629" />
            <div className="flex items-center w-full" data-id="element-630">
              {/* Timeline button - now full width for both selected and hover states */}
              <button onClick={() => onTimePointChange(tp.id)} className={`
                  py-1.5 rounded text-sm transition w-full flex justify-start px-3
                  ${selectedTimePoint === tp.id ? 'bg-blue-600 text-white font-semibold shadow-sm' : 'text-gray-800 hover:bg-gray-100'}
                `} data-id="element-631">
                {tp.label}
              </button>
              {/* DecisionPoint tooltip */}
              {tp.decisionPoint && <div className="ml-2 relative group cursor-pointer" data-id="element-632">
                  <div className="absolute left-5 top-0 w-56 p-3 rounded-md shadow-lg bg-white border text-sm z-20
                    opacity-0 group-hover:opacity-100 group-hover:visible invisible transition-opacity duration-200" data-id="element-633">
                    <p className="font-medium text-gray-900" data-id="element-634">
                      {tp.decisionPoint.title}
                    </p>
                    <p className="text-gray-600 text-xs mt-1" data-id="element-635">
                      {tp.decisionPoint.description}
                    </p>
                  </div>
                </div>}
            </div>
            {/* Resupply label - moved to 5d timepoint */}
            {tp.id === '5d' && <div className="-mt-2 ml-3" data-id="element-636">
                <span className="text-xs text-red-600 font-medium" data-id="element-637">
                  Resupply Needed
                </span>
              </div>}
          </div>)}
      </div>
    </div>;
};